<template>
  <div>
    <div class="section-5">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="row">
            <div class="col-lg-5 col-sm-12">
              
              <ul class="footer-link">
                <h3>درباره ما :</h3>
                <div class="links">
                  <li>
                    <router-link class="link" :to="{name:'AboutUs' , query:{section:'aboutus'}}"><i class="fa fa-user-circle-o"></i> درباره ما</router-link>
                  </li>
                  <li>
                    <router-link class="link" :to="{name:'AboutUs' , query:{section:'rules'}}"><i class="fa fa-balance-scale"></i> قوانین و مقررات</router-link>
                  </li>
                  <li>
                    <router-link class="link" :to="{name:'AboutUs' , query:{section:'contactUs'}}"><i class="fa fa-phone"></i> تماس با ما</router-link>
                  </li>
                  <li>
                    <router-link class="link" :to="{name:'AboutUs' , query:{section:'faq'}}"><i class="fa fa-question"></i> سوالات متداول</router-link>
                  </li>
                  <li>
                    <router-link class="link" :to="{name:'AboutUs' , query:{section:'earning'}}"><i class="fa fa-money"></i> کسب درآمد</router-link>
                  </li>
                  
                </div>
              </ul>

            </div>
            <div class="col-lg-7 col-sm-12">
              
              <ul class="footer-link col2">
                <h3>محصولات : </h3>
                <div class="links">
                  <li>
                    <router-link :to="{name:'Transaction'}" class="link"><i class="fa fa-exchange"></i> بازار آنلاین (otc)</router-link>
                  </li>
                  <li>
                    <router-link :to="{name:'Articles'}" class="link"><i class="fa fa-graduation-cap"></i> آکادمی ارزینه (مرکز آموزش و پژوهش های کاربردی)</router-link>
                  </li>
                  <li>
                    <router-link :to="{name:'Article', params:{slug:'arzineCard'}}" class="link" ><i class="fa fa-address-card-o"></i> ارزینه کارت (تسهیلات ویژه)</router-link>
                  </li>
                  <li>
                    <router-link :to="{name:'Article', params:{slug:'arzineWalletCard'}}" class="link" ><i class="fa fa-credit-card-alt"></i> ولت کارت ارزینه (درگاه اختصاصی کریپتو)</router-link>
                  </li>
                  <li>
                    <router-link :to="{name:'Article', params:{slug:'arzineTravelCard'}}" class="link" ><i class="fa fa-suitcase"></i> سفرکارت ارزینه</router-link>
                  </li>
                </div>
              </ul>

            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">

          <div class="row">

            <div class="col-lg-4 col-sm-12">
              <ul class="footer-link col2">
                <h3>پشتیبانی :</h3>
                <div class="links">
                  <li>
                    <router-link :to="{name: $route.name , query:{support:'on'} }" class="link">
                        <div class="d-flex justify-content-between">
                            <span><i class="fa fa-internet-explorer"></i> سایت : </span>
                            <span>ARZINE.org</span>
                        </div>
                    </router-link>
                  </li>
                  <li>
                    <a target="_blank" :href="'https://t.me/'+state_setting.telegram_support_link" class="link">
                        <div class="d-flex justify-content-between">
                            <span><i class="fa fa-telegram"></i> تلگرام : </span>
                            <span>{{ state_setting.telegram_support_link }}@</span>
                        </div>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="'mailto:'+state_setting.email_support_link" class="link">
                        <div class="d-flex justify-content-between">
                            <span><i class="fa fa-google"></i> ایمیل :  </span>
                            <span>{{ state_setting.email_support_link }}</span>
                        </div>
                    </a>
                  </li>
                  <!-- <li>
                    <a href="tel:09158321153" class="link" >09158321153</a>
                  </li>
                  <li>
                    <a href="tel:051-36033715" class="link" >051-36033715</a>
                  </li> -->
                </div>
              </ul>

            </div>

            <div class="col-lg-8 col-sm-12">
              
              <div class="arms-wrapper">

                <div class="arm-wrapper">
                  <img :src="StaticImageUrl + 'assets/images/samt.png'">
                  <div class="title">پروانه فنی و مهندسی</div>
                  <div class="code">120/2191397</div>
                </div>

                <div class="arm-wrapper">
                  <img :src="StaticImageUrl + 'assets/images/samt.png'">
                  <div class="title">پروانه تحقیق و توسعه</div>
                  <div class="code">120/2191854</div>
                </div>

                <div class="arm-wrapper">
                  <img :src="StaticImageUrl + 'assets/images/daraie.png'">
                  <div class="title">کد اقتصادی</div>
                  <div class="code">10380113428</div>
                </div>

                <div class="arm-wrapper">
                  <img :src="StaticImageUrl + 'assets/images/ghazaieie.png'">
                  <div class="title">شناسه ملی</div>
                  <div class="code">10380113428</div>
                </div>

                <div class="arm-wrapper">
                  <img :src="StaticImageUrl + 'assets/images/bazargani.png'">
                  <div class="title">کارت بازرگانی</div>
                  <div class="code">10380113428</div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
      <div v-if="state_setting" class="social-media">
        <a target="_blank" :href="'https://instagram.com/'+state_setting.instagram_link" class="link" >
          <i style="font-size:2.25rem" class="fa fa-instagram"></i>
        </a>
        <a target="_blank" :href="'https://t.me/'+state_setting.telegram_channel_link" class="link" >
          <i style="font-size:2rem" class="fa fa-telegram"></i>
        </a>
        <a target="_blank" :href="'mailto:'+state_setting.email_link" class="link" >
          <i style="font-size:2.5rem" class="mdi mdi-gmail"></i>
        </a>
        <a target="_blank" :href="'https://linkedin.com/in/'+state_setting.linkedin_link" class="link" >
          <i style="font-size:2rem" class="fa fa-linkedin-square"></i>
        </a>
        <!-- <a v-if="state_setting.google_plus_link" target="_blank" :href="'https://linkedin.com/in/'+state_setting.google_plus_link" class="link" >
          <i style="font-size:2.5rem" class="mdi mdi-google-plus"></i>
        </a> -->
      </div>

      <div class="doc-pulses">
          <div class="doc-pulses__items">
            <div class="doc-pulses__items-animation-wrapper">
                <div class="doc-marquee" direction="right" width="100%">
                  
                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

                    <div class="doc-pulse-item">
                        <b>عضو جامعه مهندسان مشاور ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو کانون مشاوران اعتباری و سرمایه گذاری بانکی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت رئیسه انجمن مشاوران بین المللی مدیریت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مشاوران مدیریت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مراکز تحقیق و توسعه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو انجمن مدیران کیفیت ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو خانه صنعت ، معدن و تجارت جوانان ایران</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و هلند</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتحادیه صادر کنندگان خدمات فنی و مهندسی</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>دارای پروانه فنی مهندسی از وزارت صنعت ، معدن و تجارت</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو اتاق بازرگانی و صنایع و معادن ایران و ایتالیا</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو شورای بازرگانی ایران و ترکیه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>عضو هیئت علمی مرکز علوم و نشر دانش های کاربردی و مدرس دانشگاه</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی هلدینگ های برتر و شرکت های پیشرو</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب اجلاس بین المللی مدیران موفق جهان اسلام</b>
                    </div>
                    <div class="doc-pulse-item">
                        <b>منتخب جشنواره ملی مدیران و تولید کنندگان جوان</b>
                    </div>

              </div>
            </div>
          </div>
      </div>

      <hr class="footer-hr">
      <br>
      <div class="text-center text-light">
        خرید و فروش دارایی هاي دیجیتال به دلیل نوسانات قیمت تجارتی پر ریسک به شمار می رود. علاقه مندان لازم است با علم و آگاهی کافی نسبت به معامله اقدام نمایند. صرافی ارزینه به کاربران خود توصیه و سیگنالی براي خرید یا فروش نمی دهد و مسئولیت کلیه معاملات بر عهده ي کاربر خواهد بود.
      </div>
    </div>

  </div>
</template>
<script>
import Modal from '../components/Modal.vue'
export default {
  name: 'Footer',
  data : () => ({
    about_us_modal : false
  }),
  components:{
    Modal
  },
  methods: {
    getPulseWidth()
    {
        var elements = this.$el.querySelectorAll('.doc-pulse-item');
        var width = 0
        for(var i = 0; i < elements.length; i++){
            width +=  elements[i].offsetWidth;
        }
        document.documentElement.style.setProperty('--docvari' , `${width}px`)
        document.documentElement.style.setProperty('--docvarisec' , `${width*1.5}s`)
    }
  },
  mounted() {
    this.getPulseWidth()
  }
}
</script>
<style scoped>

/* .aboutus-wrapper{ */
    /* padding: 40px 70px; */
    /* background: #fff; */
/* } */
.aboutus-wrapper .aboutus-inner{
    padding: 40px;
    border-radius: 20px;
    background: var(--theme2);
    color: #fff !important;
}
.link {
    display: block;
}
.link i{
  font-size: 1.25rem;
  margin: 0 2px;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.arms-wrapper{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.arm-wrapper{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  color: #fff;
  width: 170px;
}
.arm-wrapper img{
  height: 120px;
}
.arm-wrapper .title{
  font-size: 12px;
}


.doc-marquee{
    padding: 8px 0;
    display: flex;
    --vari : 0px;
    --varisec : 0s;
}
.doc-pulses {
    width: 100%;
    display: flex;
    opacity: 1!important;
    background: #000000;
    position: relative;
    height: 65px;
    margin: 0;
    border-bottom: 5px solid #0a1146;
}
.doc-pulses__items {
    flex: 1 1;
    display: flex;
    font-size: 16px;
    position: relative;
    overflow: hidden;
    /* color: #fff; */
    padding: 5px;
    align-items: center;
    white-space: nowrap;
}

.doc-pulses__heading-icon {
    width: 22px;
    margin: 1px 4px;
}
.doc-pulses__items-animation-wrapper {
    width: 100%;
    animation: infinite linear pulses calc(var(--docvarisec) / 200);
    padding-right: 100%;
}
.doc-pulses__items-animation-wrapper:hover {
    cursor: grabbing;
    animation-play-state: paused;
}
.doc-pulses__items-animation-wrapper .doc-pulse-item {
    padding: 0 18px;
    color: #fcfcfc;
    display: inline-block; 
    border-left: .5px solid #4c7597;
}
.doc-pulses__items-animation-wrapper .doc-pulse-item p{
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    font-size: 16px;
}
/* .pulses__items-animation-wrapper .pulse-item:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 16px;
    background: hsla(0,0%,100%,.3);
    margin: 0 0 0 12px;
} */
@keyframes pulses {
    0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    }
    100% {
        -webkit-transform: translate3d(calc(var(--docvari) + 100%),0,0);
        transform: translate3d(calc(var(--docvari) + 100%),0,0);
    }
}
</style>